/** Public demo video (landing footer + /demo page). */
export const DEMO_LOOM_URL =
  "https://www.loom.com/share/f87440e4bea04ef5b20bd889a0010f42";

/** Loom embed URL for the on-site /demo player. */
export const DEMO_LOOM_EMBED_URL =
  "https://www.loom.com/embed/f87440e4bea04ef5b20bd889a0010f42";

/** Shared Calendly booking link (landing CTAs, header, /demo). */
export const CALENDLY_URL = "https://calendly.com/info-ccoo/30min";
